export default function MultiselectOptions() {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      simple: '=',
    },
    template: `
      <div class="manage-list">
        <div class="center-vertically multiselect-options">
          <div class="multiselect-inner-container" ng-class="{simple: simple}" ng-transclude>
          </div>
        </div>
      </div>
    `,
  };
}
